export interface FaqItem {
    topicId: string,
    question: string;
    answer: string;
    open?: boolean;
  }

export const FAQ_DATA: FaqItem[] =  [
    {
      topicId: '1.1',
      question: 'Как перейти в Каталог спроса?',
      answer: `1) Выбрать в меню раздел «Каталог» – подраздел «Каталог спроса».<br>
               2) Отобразится Каталог спроса.<br>
                ИЛИ <br>
               1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
               2) Для выбранной сессии активировать функцию контекстного меню <strong><em>«Перейти в Каталог спроса»</em></strong>.<br>
               3) Отобразится Каталог спроса.`,
      open: false
    },
    {
      topicId: '1.1',
      question: 'Как перейти в Каталог предложений?',
      answer: `1) Выбрать в меню раздел «Каталог» – подраздел «Каталог предложений».<br>
               2) Отобразится Каталог предложений.<br>
                ИЛИ <br>
               1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
               2) Для выбранной сессии активировать функцию контекстного меню <strong><em>«Перейти в Каталог предложений»</em></strong>.<br>
               3) Отобразится Каталог предложений.`,
      open: false
    },
    {
      topicId: '1.1',
      question: 'Как перейти к просмотру заявки из Каталога спроса/Каталога предложений?',
      answer: `1) Выбрать в меню раздел «Каталог» – «Каталог спроса» / «Каталог предложений».<br>
               2) Выбрать в списке необходимый товар/услугу.<br>
               2) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.<br>
               3) Отобразится информация по заявке.`,
      open: false
    },
    {
      topicId: '1.1',
      question: 'Как перейти из Каталога спроса/Каталога предложений в раздел «Управления заявками»?',
      answer: `1) Выбрать в меню раздел «Каталог» – «Каталог спроса» / «Каталог предложений».<br>
               2) Выбрать в списке необходимый товар/услугу.<br>
               3) Активировать функцию контекстного меню <strong><em>«Перейти в Управление заявками»</em></strong>.<br>
               4) Отобразится страница подраздела «Управление заявками».`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как просмотреть расписание сессий?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) На странице «Расписание сессий» отобразятся сессии, дата проведения которых больше либо равна текущей дате.`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как просмотреть сумму задатка на сессию?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) Для выбранной сессии вызвать функцию контекстного меню <strong><em>«Просмотреть задаток на сессию»</em></strong>.<br>
                3) Отобразится страница «Информация о задатке».`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как просмотреть заявки, поданные на выбранную сессию?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) Для выбранной сессии вызвать функцию контекстного меню <strong><em>«Просмотреть заявки на сессию»</em></strong>.<br>
                3) Отобразится страница «Управление заявками».`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как просмотреть регистрации на выбранную сессию?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) Для выбранной сессии вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
                3) Отобразится страница «Регистрации на сессию».`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как выгрузить данные о регистрации участников в качестве покупателей/продавцов на торговую сессию?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) Для выбранной сессии вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
                3) Отобразится страница «Регистрации на сессию».<br>
                4) Нажать на кнопку  <i class="export"></i>.`,
      open: false
    },
    {
      topicId: '2.1',
      question: 'Как получить подробную информацию об участниках торгов?',
      answer: ` 1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
                2) Для выбранной сессии вызвать функцию контекстного меню <strong><em>«Отчет Участники торгов»</em></strong>.<br>`,
      open: false
    },
    {
      topicId: '2.2',
      question: 'Как создать сессию?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать из выпадающего списка секцию.<br>
               2) Нажать на кнопку <strong>«Создать сессию»</strong>.<br>
               3) В открывшейся форме заполнить блоки параметров.<br>
               4) Сохранить по кнопке <strong>«Создать сессию»</strong>.`,
      open: false
    },
    {
      topicId: '2.2',
      question: 'Как создать сессию по шаблону?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать из выпадающего списка секцию.<br>
               2) Нажать на кнопку <strong>«Создать сессию по шаблону»</strong>.<br>
               3) В открывшемся окне выбрать из списка необходимый шаблон. Нажать на кнопку <strong>«Создать сессию по шаблону»</strong>.<br>
               4) На появившейся форме заполнить блоки параметров.<br>
               5) Сохранить по кнопке.<br>
               ИЛИ <br>
               1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессии». Выбрать из выпадающего списка секцию.<br>
               2) Перейти на вкладку <em>«Активные»</em>.<br>
               3) Выбрать в списке необходимый шаблон сессии.<br>
               4) Активировать функцию контекстного меню <strong><em>«Создать сессию по шаблону»</em></strong>.<br>
               5) На появившейся форме заполнить блоки параметров.<br>
               6) Сохранить по кнопке.`,
      open: false
    },
    {
      topicId: '2.3',
      question: 'Как создать шаблон сессии?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессий». Выбрать из выпадающего списка секцию.<br>
               2) Нажать на кнопку <strong>«Создать шаблон»</strong>.<br>
               3) На появившейся форме заполнить блоки параметров.<br>
               4) Сохранить по кнопке.`,
      open: false
    },
    {
      topicId: '2.3',
      question: 'Как создать шаблон сессии для проведения торгов с товарами-аналогами?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессий». Выбрать из выпадающего списка секцию.<br>
               2) Нажать на кнопку <strong>«Создать шаблон»</strong>.<br>
               3) На появившейся форме заполнить блоки параметров. В блоке «Обязательные параметры сессии» указанные поля должны быть заполнены следующим образом: <br>
               – «Вид торгов» – «простой аукцион покупателя»;<br>
               – «Тип торгов» – «по цене» или «по формуле с котировкой;<br>
               – «Сборный лот» – только простые лоты;<br>
               – «Форма подачи заявки на покупку» – <em>«подача заявки»</em> или <em>«все»</em>;<br>
               4) После заполнения блока «Товары» отобразится блок «Товары-аналоги».<br>
               5) Заполнить блок «Товары-аналоги» и все последующие блоки.<br>
               6) Сохранить по кнопке.`,
      open: false
    },
    {
      topicId: '2.4',
      question: 'Как просмотреть активные/архивные/удаленные сессии для выбранной секции?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать из выпадающего списка секцию.<br>
               2) Перейти на вкладку <em>«Активные»</em> / <em>«Архивные»</em> / <em>«Удаленные»</em>.<br>
               3) Отобразятся активные, архивные или удаленные сессии для выбранной секции.`,
      open: false
    },
    {
      topicId: '2.4',
      question: 'Как просмотреть подробную информацию по сессии?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать из выпадающего списка секцию.<br>
               2) Перейти на вкладку <em>«Активные»</em> / <em>«Архивные»</em> / <em>«Удаленные»</em>.<br>
               3) Выбрать в списке необходимую сессию.<br>
               4) Активировать функцию контекстного меню <strong><em>«Просмотреть сессию»</em></strong>.`,
      open: false
    },
    {
      topicId: '2.4',
      question: 'Как просмотреть активные/удаленные шаблоны сессий для выбранной секции?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессий». Выбрать из выпадающего списка секцию.<br>
               2) Перейти на вкладку <em>«Активные»</em> / <em>«Удаленные»</em>.<br>
               3) Отобразятся активные/удаленные шаблоны сессий для выбранной секции.`,
      open: false
    },
    {
      topicId: '2.4',
      question: 'Как просмотреть подробную информацию по шаблону сессии?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессий». Выбрать из выпадающего списка секцию.<br>
               2) Перейти на вкладку <em>«Активные»</em> / <em>«Удаленные»</em>.<br>
               3) Выбрать в списке необходимый шаблон сессии.<br>
               4) Активировать функцию контекстного меню <strong><em>«Просмотреть шаблон»</em></strong>.`,
      open: false
    },
    {
      topicId: '2.5',
      question: 'Как скопировать сессию, чтобы не заполнять данные сессии вручную во время ее создания?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em> / <em>«Архивные»</em>.<br>
                3) Выбрать в списке необходимую сессию.<br>
                4) Активировать функцию контекстного меню <strong><em>«Копировать сессию»</em></strong>.<br>
                5) В открывшемся окне скорректировать необходимые параметры.<br>
                6) Нажать <strong>«Создать сессию»</strong>.`,
      open: false
    },
    {
      topicId: '2.4',
      question: 'Как отредактировать сессию?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
              2) Перейти на вкладку <em>«Активные»</em>.<br>
              3) Выбрать в списке необходимую сессию.<br>
              4) Активировать функцию контекстного меню <strong><em>«Редактировать сессию»</em></strong>.<br>
              5) В открывшемся окне внести изменения.<br>
              6) Нажать <strong>«Сохранить изменения»</strong>.`,
      open: false
    },
    {
      topicId: '2.5',
      question: 'Как удалить сессию?',
      answer: ` 1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em>.<br>
                3) Выбрать в списке необходимую сессию.<br>
                4) Активировать функцию контекстного меню <strong><em>«Удалить сессию»</em></strong>.
                5) В открывшемся окне указать причину удаления, нажать кнопку <strong>«Удалить сессию»</strong>.`,
      open: false
    },
    {
      topicId: '2.5',
      question: 'Как скопировать шаблон сессии, чтобы не заполнять данные шаблона вручную?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em> / <em>«Удаленные»</em>.<br>
                3) Выбрать в списке необходимый шаблон сессии.<br>
                4) Активировать функцию контекстного меню <strong><em>«Копировать шаблон»</em></strong>.<br>
                5) В открывшемся окне скорректировать необходимые параметры.<br>
                6) Нажать <strong>«Копировать шаблон»</strong>.`,
      open: false
    },
    {
      topicId: '2.5',
      question: 'Как отредактировать шаблон сессии?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em>.<br>
                3) Выбрать в списке необходимый шаблон сессии.<br>
                4) Активировать функцию контекстного меню <strong><em>«Редактировать шаблон»</em></strong>.<br>
                5) В открывшемся окне скорректировать необходимые параметры.<br>
                6) Нажать <strong>«Сохранить изменения»</strong>.`,
      open: false
    },
    {
      topicId: '2.5',
      question: 'Как удалить шаблон сессии?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Шаблоны сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em>.<br>
                3) Выбрать в списке необходимый шаблон сессии.<br>
                4) Активировать функцию контекстного меню <strong><em>«Удалить шаблон»</em></strong>.<br>
                5) В открывшемся окне подтвердить удаление шаблона сессии`,
      open: false
    },
    {
      topicId: '2.6',
      question: 'Как синхронизировать сессию с шаблоном и моделями?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
              2) Перейти на вкладку <em>«Активные»</em>.<br>
              3) Выбрать в списке необходимую сессию.<br>
              4) Активировать функцию контекстного меню <strong><em>«Синхронизировать с шаблоном и моделями»</em></strong>.<br>
              5) В открывшемся окне подтвердить синхронизацию по кнопке.`,
      open: false
    },
    {
      topicId: '2.7',
      question: 'Как перевести сессию в стадию «Открыт прием заявок…»?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em> / <em>«Архивные»</em>.<br>
                3) Выбрать в списке необходимую сессию.<br>
                4) Активировать функцию контекстного меню <strong><em>«Перевести в стадию «Открыт прием заявок…»»</em></strong>.<br>
                5) В открывшемся окне выбрать необходимый параметр.<br>
                6) Сохранить по кнопке.`,
      open: false
    },
    {
      topicId: '2.7',
      question: 'Как завершить обработку заявок, поданных на сессию?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
              2) Перейти на вкладку <em>«Активные»</em>.<br>
              3) Выбрать в списке необходимую сессию.<br>
              4) Активировать функцию контекстного меню <strong><em>«Завершить обработку заявок»</em></strong>.<br>
              5) Отобразится сообщение о завершении стадии приема заявок.`,
      open: false
    },
    {
      topicId: '2.7', 
      question: 'Как завершить стадию приема заявок?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
                2) Выбрать в списке необходимую сессию.<br>
                3) Вызвать контекстное меню и активировать функцию <strong><em>«Завершить обработку заявок»</em></strong>.`,
      open: false
    },
    {
      topicId: '2.7',
      question: 'Как завершить обработку сессии?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
              2) Выбрать в списке необходимую сессию.<br>
              3) Вызвать контекстное меню и активировать функцию <strong><em>«Завершить обработку сессии»</em></strong>.`,
      open: false
    },
    {
      topicId: '2.8',
      question: 'Как перенести сессию в торги?',
      answer:  `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
                2) Перейти на вкладку <em>«Активные»</em> / <em>«Архивные»</em>.<br>
                3) Выбрать в списке необходимую сессию.<br>
                4) Активировать функцию контекстного меню <strong><em>«Перевести сессию в торги»</em></strong>.
                Функция недоступна для выбора, если сессия не подходит для переноса из-за неподходящего статуса или стадии.`,
      open: false
    },
    {
      topicId: '2.8',
      question: 'Как перенести сессию в архив?',
      answer: `1) Перейти в раздел «Сессии» – «Управление сессиями (НТС)» – «Сессии». Выбрать секцию из выпадающего списка.<br>
              2) Выбрать в списке необходимую сессию.<br>
              3) Активировать функцию контекстного меню <strong><em>«Перенести в архив»</em></strong>.<br>
              4) В появившемся окне подтвердить перенос сессии.<br>
              5) Сессия будет перенесена на вкладку <strong><em>«Архив»</em></strong>.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как просмотреть заявки, поданные на выбранную сессию?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В параметрах фильтрации выбрать необходимую сессию.<br>
               3) Справа от параметров фильтрации отобразятся заявки, поданные на выбранную сессию.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как просмотреть подробную информацию по заявке?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               3) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как отредактировать поданную на сессию заявку?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               3) Активировать функцию контекстного меню <strong><em>«Редактировать заявку»</em></strong>.<br>
               4) Во всплывающем окне подтвердить выполнение операции.<br>
               5) В открывшейся форме внести необходимые изменения.<br>
               6) Нажать <strong>«Сохранить»</strong>.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как отклонить поданную на сессию заявку?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               3) Активировать функцию контекстного меню <strong><em>«Отклонить заявку»</em></strong>.<br>
               4) В появившемся окне указать причину отклонения и нажать <strong>«Отклонить заявку»</strong>.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как восстановить поданную на сессию заявку?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) Перейти на вкладку <em>«Отклоненные»</em>.<br>
               3) В списке выбрать одну или несколько заявок.<br>
               4) Активировать функцию контекстного меню <strong><em>«Восстановить заявку»</em></strong>.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как перенести в торги заявки, поданные вне регламента?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               3) Активировать функцию контекстного меню <strong><em>«Перенести в торги»</em></strong> или нажать на кнопку <i class="transferToBids"></i> на боковой панели.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как включить заявки в реестр?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
              2) В списке заявок выбрать необходимую.<br>
              3) Активировать функцию контекстного меню <strong><em>«Включить заявку в реестр»</em></strong> или нажать на кнопку <i class="registr"></i> на боковой панели.`,
      open: false
    },
    {
      topicId: '3.1',
      question: 'Как просмотреть изменения, внесенные в заявку трейдером?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               3) Активировать функцию контекстного меню <strong><em>«Показать изменения»</em></strong> или нажать на кнопку <i class="changes"></i> на боковой панели.`,
      open: false
    },
    {
      topicId: '3.1', 
      question: 'Как установить/изменить индивидуальный шаг цены для выбранной заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
              2) В списке заявок выбрать необходимую.<br>
              3) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.<br>
              4) На открывшейся странице нажать на кнопку <strong>«Изменить шаг цены»</strong>.<br>
              5) В открывшейся форме скорректировать значение в поле «Шаг цены».<br>
              6) Нажать <strong>«Сохранить»</strong>.<br>
              ИЛИ <br>
              1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция». <br>
              2) В списке заявок выбрать необходимую.<br>
              3) Активировать функцию контекстного меню <strong><em>«Изменить шаг цены»</em></strong>.<br>
              4) В открывшейся форме скорректировать значение в поле «Шаг цены».<br>
              5) Нажать <strong>«Сохранить»</strong>.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как посмотреть имеющиеся в системе модели заявок?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Отобразится список моделей заявок.<br>
               3) Доступен просмотр активных, планируемых и удаленных моделей заявок.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как создать модель заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Нажать на кнопку <strong>«Создать модель заявки»</strong>.<br>
               3) В открывшейся форме заполнить сгруппированные по блокам параметры.<br>
               4) Нажать на кнопку <strong>«Создать модель заявки»</strong>.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как создать модель заявки с использованием шаблона?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Нажать на кнопку <strong>«Создать модель заявки»</strong>.<br>
               3) В открывшейся форме выбрать из списка «Шаблон сессии».<br>
               4) Заполнить сгруппированные по блокам параметры.<br>
               5) Нажать на кнопку <strong>«Создать модель заявки»</strong>.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как просмотреть модель заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Выбрать в списке необходимую модель заявки.<br>
               3) Активировать функцию контекстного меню <strong><em>«Просмотреть модель заявки»</em></strong>.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как отредактировать модель заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Выбрать в списке необходимую модель заявки.<br>
               3) Активировать функцию контекстного меню <strong><em>«Редактировать модель заявки»</em></strong>.<br>
               4) Внести необходимые изменения.<br>
               5) Сохранить по кнопке.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как удалить модель заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Выбрать в списке необходимую модель заявки.<br>
               3) Активировать функцию контекстного меню <strong><em>«Удалить модель заявки»</em></strong>.<br>
               4) В появившемся окне подтвердить удаление модели заявки.`,
      open: false
    },
    {
      topicId: '3.2',
      question: 'Как изменить срок действия модели заявки?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор моделей».<br>
               2) Выбрать в списке необходимую модель заявки.<br>
               3) Активировать функцию контекстного меню <strong><em>«Изменить срок действия модели заявки»</em></strong>.<br>
               4) В появившемся окне выберите дату окончания действия модели заявки.<br>
               5) Сохраните по кнопке.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как посмотреть список имеющихся в системе правил?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Отобразится список правил.<br>
               3) Доступен просмотр активных, планируемых и удаленных правил.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как создать правило?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Нажать на кнопку <strong>«Создать правило»</strong>.<br>
               3) В открывшейся форме заполнить сгруппированные по блокам параметры.<br>
               4) Нажать на кнопку <strong>«Создать правило»</strong>.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как просмотреть подробную информацию о выбранном правиле?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Выбрать в списке необходимое правило.<br>
               3) Активировать функцию контекстного меню <strong><em>«Просмотреть правило»</em></strong>.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как отредактировать правило?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Выбрать в списке необходимое правило.<br>
               3) Активировать функцию контекстного меню <strong><em>«Редактировать правило»</em></strong>.<br>
               4) Внести необходимые изменения и сохранить их по кнопке <strong>«Редактировать правило»</strong>.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как скопировать правило, чтобы не заполнять данные вручную при его создании?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Выбрать в списке необходимое правило.<br>
               3) Активировать функцию контекстного меню <strong><em>«Копировать правило»</em></strong>.<br>
               4) В появившейся форме внести необходимые изменения и сохранить их по кнопке`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как удалить правило?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Выбрать в списке одно или несколько правил.<br>
               3) Активировать функцию контекстного меню <strong><em>«Удалить правило»</em></strong>.<br>
               4) В появившемся окне подтвердить удаление правила.`,
      open: false
    },
    {
      topicId: '3.3',
      question: 'Как изменить срок действия правила?',
      answer: `1) Перейти в раздел «Заявки» – «Конструктор правил».<br>
               2) Выбрать в списке необходимое правило.<br>
               3) Активировать функцию контекстного меню <strong><em>«Изменить срок действия»</em></strong>.<br>
               4) В появившемся окне выберите дату окончания действия правила.<br>
               5) Сохраните по кнопке.`,
      open: false
    },
    {
      topicId: '3.4',
      question: 'Как перенести нереализованные объемы с архивной сессии на будущую торговую сессию?',
      answer: `1) Перейти в раздел «Заявки» – «Архив» – «Нереализованные объемы».<br>
               2) Выбрать из выпадающего списка архивную сессию. На вкладке <em>«Для переноса»</em> отобразится перечень нереализованных объемов по лотам.<br>
               3) Выбрать необходимые лоты и нажать на кнопку <strong>«Перенести лоты»</strong>.<br>
               4) В открывшемся окне выбрать сессию, на которую нужно перенеси выбранные лоты.<br>
               5)	Нажать <strong>«Перенести»</strong>.`,
      open: false
    },
    {
      topicId: '3.4',
      question: 'Как получить подробную информацию о сделках, заключенных по окончании выбранной сессии?',
      answer: `1) Перейти в раздел «Заявки» – «Архив» – «Отчет „Сделки“».<br>
               2) Выбрать из выпадающего списка секцию.<br>
               3)	Указать период отбора сессий.<br>
               4) Выбрать из выпадающего списка сессию.<br>
               5)	Отобразится подробная информация по сделкам.`,
      open: false
    },
    {
      topicId: '3.4',
      question: 'Как получить подробную информацию о заявках, поданных на выбранную сессию?',
      answer: `1) Перейти в раздел «Заявки» – «Архив» – «Отчет „Заявки на торговую сессию“».<br>
               2) Выбрать из выпадающего списка секцию.<br>
               3) Указать период отбора сессий.<br>
               4) Выбрать из выпадающего списка сессию.<br>
               5)	Отобразится подробная информация по заявкам.`,
      open: false
    },
    {
      topicId: '4.1',
      question: 'Как перенести сессию в торги?',
      answer: `1) Перейти в меню «Сессии» – «Управление сессиями» – «Сессии».<br>
               2) Выбрать необходимую секцию.<br>
               3) На вкладке <em>«Активные»</em> выбрать сессию для переноса. Для успешного переноса сессия должна соответствовать следующим критериям:<br>
                 – стадия – «Завершена обработка заявок», статус – <em>«Подготовка»</em> или <em>«Не перенесена в торги»</em>;<br>
                 – стадия – «Завершен перенос сессии в торги» или <em>«Активирована»</em>, статус – <em>«Торги» (для повторного переноса)</em>.<br>
               4) Активировать функцию контекстного меню <strong><em>«Перенести сессию в торги»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.1',
      question: 'Как перейти в торги?',
      answer: `– Перейти в меню «Сессии» – «Расписание сессий» – выбрать функцию контекстного меню <strong><em>«Перейти в торги»</em></strong>.<br>
               – В разделе «Торги сегодня» нажать на кнопку <strong>«Перейти в торги»</strong>.<br>
               – В окне «Вход в торги» нажать на кнопку <strong>«Перейти в торги»</strong>.`,
      open: false
    },
    {
      topicId: '4.1',
      question: 'Как активировать заявку на продажу в торгах?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em>.<br>
                2) С помощью фильтра отобразить неактивные заявки.<br>
                3) Выбрать одну или несколько заявок.<br>
                4) Вызвать функцию контекстного меню <strong><em>«Активировать заявку»</em></strong>.<br>
                5) В отобразившемся окне настроить параметры допуска.<br>
                6) Нажать <strong>«Активировать»</strong>.<br>
                7) При отсутствии ошибок заявке будет присвоен статус «Активная», она отобразится на вкладке <em>«Торги»</em>.`,
      open: false
    },
    {
      topicId: '4.2',
      question: 'Как добавить период сессии в расписание?',
      answer:  `1) Перейти в раздел «Торги сегодня» – вкладка <em>«Настройки»</em>.<br>
                2) Нажать на кнопку <strong>«Добавить период»</strong>.<br>
                3) В открывшемся окне заполнить необходимые параметры.<br>
                4) Нажать <strong>«Добавить»</strong>.`,
      open: false
    },
    {
      topicId: '4.2', 
      question: 'Как запустить период сессии?',
      answer:  `Нажать на кнопку <i class="startGreenIcon"></i> в колонке «Действия» вкладки <em>«Настройки»</em>.`,
      open: false
    },
    {
      topicId: '4.2', 
      question: 'Как приостановить период сессии?',
      answer:  `Нажать на кнопку <i class="pauseOrangeIcon"></i> в колонке «Действия» вкладки <em>«Настройки»</em>.`,
      open: false
    },
    {
      topicId: '4.2', 
      question: 'Как возобновить период сессии после приостановки?',
      answer:  `Нажать на кнопку <i class="startGreenIcon"></i> в колонке «Действия» вкладки <em>«Настройки»</em>.`,
      open: false
    },
    {
      topicId: '4.2',
      question: 'Как изменить продолжительность текущего периода сессии?',
      answer:  `1) Нажать на элемент <i class="pencilEdit"></i> в колонке «Продолжительность» вкладки <em>«Настройки»</em>.<br>
                2) В открывшемся окне необходимо указать «Дополнительное время» и <strong>«Сохранить»</strong> введенное значение.`,
      open: false
    },
    {
      topicId: '4.2',
      question: 'Как изменить продолжительность запланированного периода сессии?',
      answer:  `1) Нажать на элемент <i class="pencilEdit"></i> в колонке «Действия» вкладки <em>«Настройки»</em>.<br>
                2) В открывшемся окне внести необходимые изменения и <strong>«Сохранить»</strong> по кнопке.`,
      open: false
    },
    {
      topicId: '4.2',
      question: 'Как завершить период сессии?',
      answer:  `1) Нажать на кнопку <i class="stopRedIcon"></i> в колонке «Действия» вкладки <em>«Настройки»</em>.<br>
                2) В отобразившемся окне выбрать вариант завершения периода.<br>
                3) Нажмите <strong>«Завершить»</strong>.`,
      open: false
    },
    {
      topicId: '4.3',
      question: 'Как изменить шаг цены?',
      answer:  `1) Нажать на элемент <i class="pencilEdit"></i> в колонке «Шаг цены, %» вкладки <em>«Настройки»</em>.<br>
                2) В открывшемся окне изменить шаг цены с помощью кнопок  -/+ , сохранить новое значение.`,
      open: false
    },
    {
      topicId: '4.3',
      question: 'Как установить/изменить индивидуальный шаг цены?',
      answer: `1) Перейти на вкладку <em>«Торги»</em> или <em>«Заявки»</em>.<br>
               2) Выбрать в списке необходимый лот.<br>
               3) Вызвать функцию контекстного меню <strong><em>«Изменить шаг цены»</em></strong>.<br>
               4) В открывшемся окне скорректировать значение поля «Шаг цены».<br>
               5) Нажать на кнопку <strong>«Сохранить»</strong>.<br>
               ИЛИ <br>
               1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) В списке заявок выбрать необходимую.<br>
               5) Активировать функцию контекстного меню <strong><em>«Изменить шаг цены»</em></strong>.<br>
               4) В открывшемся окне скорректировать значение поля «Шаг цены».<br>
               5) Нажать на кнопку <strong>«Сохранить»</strong>.`,
      open: false
    },
    {
      topicId: '4.4',
      question: 'Как изменить время подачи ставки?',
      answer:  `1) Нажать на элемент <i class="pencilEdit"></i> в колонке «Время подачи ставки» вкладки <em>«Настройки»</em>.<br>
                2) В открывшемся окне внести необходимые изменения и <strong>«Сохранить»</strong> по кнопке.`,
      open: false
    },
    {
      topicId: '4.5',
      question: 'Как просмотреть регистрации участников на торговую сессию?',
      answer: `1) Перейти в подраздел «Расписание сессий».<br>
               2) Вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
               ИЛИ <br>
               1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
               2) Нажать на кнопку <strong>«Регистрации»</strong>.`,
      open: false
    },
    {
      topicId: '4.5',
      question: 'Как выгрузить данные о регистрации участников в качестве покупателей/продавцов на торговую сессию?',
      answer: ` 1) Перейти в подраздел «Расписание сессий».<br>
                2) Вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
                3) Нажать на кнопку  <i class="export"></i> над списком регистраций.`,
      open: false
    },
    {
      topicId: '4.5',
      question: 'Как отменить регистрацию участника на торговую сессию?',
      answer: `1) Перейти в подраздел «Расписание сессий».<br>
               2) Выбрать сессию (статус – «Подготовка»), по которой необходимо отменить регистрацию трейдера в качестве покупателя/продавца.<br>
               3) Вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
               4) В открывшемся списке выбрать одного или нескольких трейдеров.<br>
               5) Вызвать функцию контекстного меню <strong><em>«Отменить регистрацию»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.5',
      question: 'Как восстановить регистрацию участника на торговую сессию?',
      answer: `1) Перейти в подраздел «Расписание сессий».<br>
               2) Выбрать сессию (статус – «Подготовка»), по которой необходимо восстановить регистрацию трейдера в качестве покупателя/продавца.<br>
               3) Вызвать функцию контекстного меню <strong><em>«Просмотреть регистрации на сессию»</em></strong>.<br>
               4)	В открывшемся списке выбрать одного или нескольких трейдеров, регистрация которых была ранее отменена.<br>
               5) Вызвать функцию контекстного меню <strong><em>«Восстановить регистрацию»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.6',
      question: 'Как перенести заявки и регистрации на другого трейдера?',
      answer: `1) Перейти на вкладку <em>«Трейдеры»</em>.<br>
               2) Выбрать в списке трейдера.<br>
               3) Вызвать контекстное меню, выбрать функцию <strong><em>«Заменить трейдера»</em></strong>.<br>
               4) В появившемся окне выбрать из выпадающего списка принимающего трейдера.<br>
               5) Нажать на кнопку <strong>«Перенести»</strong>.`,
      open: false
    },
    {
      topicId: '4.6',
      question: 'Как исключить трейдера из торгов?',
      answer: `1) Перейти на вкладку <em>«Трейдеры»</em>.<br>
               2) Выбрать в списке трейдера.<br>
               3) Вызвать контекстное меню, выбрать функцию <strong><em>«Исключить трейдера»</em></strong>.<br>
               4) В появившемся окне указать причину исключения.<br>
               5) Нажать на кнопку <strong>«Исключить трейдера»</strong>.`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как просмотреть подробную информацию по заявке?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Для выбранной заявки активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как отредактировать заявку?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Для выбранной заявки активировать функцию контекстного меню <strong><em>«Редактировать заявку»</em></strong>.<br>
               3) В открывшейся форме внести необходимые изменения.<br>
               5) Нажать <strong>«Сохранить»</strong>.<br>
               ИЛИ <br>
               1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать необходимую заявку.<br>
               3) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
               4) В открывшейся форме нажать на кнопку <strong>«Редактировать заявку»</strong>.<br>
               5) Внести необходимые изменения и сохранить по кнопке`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как добавить заявку в наблюдаемые?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать необходимую заявку.<br>
               3) Вызвать контекстное меню и активировать функцию <strong><em>«Добавить в наблюдаемые»</em></strong>.
                  В столбце рядом с номером лота заявки отобразится иконка <i class="isObserved"></i><br>
               ИЛИ <br>
               1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать в списке необходимую заявку.<br>
               3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
               4) В открывшейся форме просмотра заявки нажать на кнопку <i class="isNotObserved"></i>.<br>
               5) Кнопка изменит вид на <i class="isObserved"></i>`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как просмотреть изменения по заявке?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать в списке необходимую заявку.<br>
               3) В контекстном меню заявки выбрать функцию <strong><em>«Показать изменения»</em></strong>.<br>
               4) В открывшейся форме отобразится информация о предыдущей и текущей версиях заявки`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как просмотреть ход торгов по заявке?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать в списке необходимую заявку.<br>
              3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть ход торгов»</em></strong>.<br>
              4) В отдельной вкладке в разрезе каждой заявки отобразятся все действия системы, работника и трейдера. <br> 
              ИЛИ <br>
              1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать в списке необходимую заявку.<br>
              3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
              4) В открывшемся окне нажать на кнопку <i class="tradingProgress"></i>.`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как просмотреть правила редактирования модели заявки?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать в списке необходимую заявку.<br>
               3) В контекстном меню заявки выбрать функцию <strong><em>«Правила редактирования модели заявки»</em></strong>.<br>
               4) Правила редактирования модели заявки отобразятся в отдельном окне.`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как отклонить заявку трейдера на сессию в торгах?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать необходимую заявку.<br>
              3) Вызвать контекстное меню и активировать функцию  <strong><em>«Отклонить заявку»</em></strong>.<br>
              ИЛИ <br>
              1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать необходимую заявку.<br>
              3) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
              4) На форме просмотра заявки нажать на кнопку <strong>«Отклонить заявку»</strong>.`,
      open: false
    },
    {
      topicId: '4.7',
      question: 'Как восстановить заявку трейдера на сессию в торгах?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em>.<br>
              2) В параметрах фильтрации указать статус «Отклоненные».
              3) Выбрать необходимую заявку.<br>
              4) Вызвать контекстное меню и активировать функцию  <strong><em>«Восстановить заявку»</em></strong>.<br>
              5) В открывшемся окне настроить параметры допуска, нажать на кнопку <strong>«Восстановить»</strong>.<br>
              ИЛИ <br>
              1) Перейти на вкладку <em>«Заявки»</em>.<br>
              2) В параметрах фильтрации указать статус «Отклоненные».
              3) Выбрать необходимую заявку.<br>
              4) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
              5) На форме просмотра заявки нажать на кнопку <strong>«Восстановить заявку»</strong>.<br>
              5) В открывшемся окне настроить параметры допуска, нажать на кнопку <strong>«Восстановить»</strong>.`,
      open: false
    },
    {
      topicId: '4.8',
      question: 'Как просмотреть сумму задатка по заявке?',
      answer: `1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать в списке необходимую заявку.<br>
              3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть задаток по заявке»</em></strong>.<br>
              4)	Отобразится информация о задатке.<br>
              ИЛИ <br>
              1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) Выбрать в списке необходимую заявку.<br>
              3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
              4) На форме просмотра заявки нажать на кнопку <i class="depositOffer"></i>.<br>
              5) Отобразится информация о задатке.<br>
              ИЛИ <br>
              1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
              2) Нажать на кнопку <strong>«Задаток»</strong>. `,
      open: false
    },
    {
      topicId: '4.8', 
      question: 'Как просмотреть информацию о суммах задатка на выбранную сессию по всем участникам?',
      answer:  `Перейти на вкладку <em>«Задаток»</em> раздела «Торги сегодня».`,
      open: false
    },
    {
      topicId: '4.9',
      question: 'Как просмотреть реестр встречных предложений по выбранной заявке?',
      answer: `1) Перейти на вкладку <em>«Торги»</em>.<br>
              2) Выбрать в списке необходимую заявку.<br>
              3) В контекстном меню заявки выбрать функцию <strong><em>«Реестр встречных предложений»</em></strong>.<br>
              4) Отобразится окно просмотра сведений о направленных на заявку встречных предложениях.<br>
              ИЛИ <br>
              1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
              2) В параметрах фильтрации указать статус «Отклоненные».
              3) Выбрать в списке необходимую заявку.<br>
              4) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
              5) Нажать на кнопку <i class="register"></i>.`,
      open: false
    },
    {
      topicId: '4.10',
      question: 'Как просмотреть подробную информацию по сделке?',
      answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
               2) Выбрать необходимую сделку.<br>
               3) Вызвать контекстное меню и активировать <strong><em>«просмотреть сделку»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.10',
      question: 'Как отказать в фиксации сделки?',
      answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
              2) Выбрать необходимую сделку.<br>
              3) Вызвать контекстное меню и активировать функцию  <strong><em>«Отказать в фиксации»</em></strong> в списке сделок.<br>
              4)	В появившемся модальном окне указать условия отказа в фиксации сделки, указать причину.<br>
              5)	В модальном окне нажать на кнопку <strong>«Отказать в фиксации»</strong>.<br>            
              ИЛИ <br>
              1) Перейти на вкладку <em>«Сделки»</em>.<br>
              2) Выбрать необходимую сделку.<br>
              3) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть сделку»</em></strong>.<br>
              4) Нажать на кнопку <strong>«Отказать в фиксации»</strong> на форме просмотра подробной информации по сделке.<br>
              5) Выполнить действия из пунктов 2, 3, описанных выше.`,
      open: false
    },
    {
      topicId: '4.10',
      question: 'Как восстановить сделку, в фиксации которой было отказано?',
      answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
               2) Выбрать необходимую сделку.<br>
               3) Вызвать функцию контекстного меню <strong><em>«Восстановить сделку»</em></strong> в списке сделок.<br>
               4) В появившемся окне подтвердить выполнение операции.<br>
              ИЛИ <br>
              1) Перейти на вкладку <em>«Сделки»</em>.<br>
              2) Выбрать необходимую сделку.<br>
              3) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть сделку»</em></strong>.<br>
              4) На форме просмотра сделки нажать на кнопку <strong>«Восстановить сделку»</strong>.<br>
              5) В появившемся окне подтвердить выполнение операции.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как просмотреть системные сообщения?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на параметр «Показывать».<br>
               3) Поставить галочку напротив параметра <em>«Системные»</em>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как добавить сообщение в наблюдаемые?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Выбрать в списке необходимое сообщение.<br>
               3) Активировать функцию контекстного меню <strong><em>«Добавить в наблюдаемые»</em></strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как перейти в чат с трейдером?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Выбрать в списке необходимое сообщение.<br>
               3) Активировать функцию контекстного меню <strong><em>«Перейти в чат с трейдером»</em></strong>.<br>
               4)	Переписка с трейдером откроется в новой вкладке браузера.<br>
               ИЛИ <br>
               1) Перейти на вкладку <em>«Заявки»</em> или <em>«Торги»</em>.<br>
               2) Выбрать в списке необходимую заявку.<br>
               3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
               4) Нажать на кнопку <i class="chat"></i>.<br>
               5)	Переписка с трейдером откроется в новой вкладке браузера.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как ответить на сообщение?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Выбрать в списке необходимое сообщение.<br>
               3) Активировать функцию контекстного меню <strong><em>«Ответить на сообщение»</em></strong>.<br>
               4)	В открывшемся окне ввести текст сообщения или выбрать из списка готовый шаблон.<br>
               5) Нажать <strong>«Отправить»</strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как создать новое сообщение?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне ввести текст сообщения или выбрать из списка готовый шаблон.<br>
               4) Нажать <strong>«Отправить»</strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как отправить сообщение всем трейдерам?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне ввести текст сообщения или выбрать из списка готовый шаблон.<br>
               4)	Активировать параметр «Написать всем трейдерам».<br>
               5) Нажать <strong>«Отправить»</strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как отправить сообщение с пометкой «срочное»?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне ввести текст сообщения или выбрать из списка готовый шаблон.<br>
               4)	Активировать параметр «Срочное сообщение».<br>
               5) Нажать <strong>«Отправить»</strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как создать шаблон сообщения?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне нажать «Создать новый шаблон».<br>
               4)	Ввести его наименование, текст сообщения и сохранить по кнопке.<br>
               5) Созданный шаблон будет доступен для выбора на вкладке <em>«Мои шаблоны»</em> в списке доступных шаблонов.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как отредактировать шаблон сообщения?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне в поле «Доступные шаблоны» выбрать необходимый.<br>
               4)	Нажать на кнопку <i class="pencilEdit"></i> рядом с наименование выбранного шаблона.<br>
               5) В открывшемся окне отредактировать название шаблона и/или текст сообщения, нажать <strong>«Сохранить»</strong>.`,
      open: false
    },
    {
      topicId: '4.11',
      question: 'Как удалить шаблон сообщения?',
      answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
               2) Нажать на кнопку <strong>«Создать сообщение»</strong>.<br>
               3) В открывшемся окне в поле «Доступные шаблоны» выбрать необходимый.<br>
               4)	Нажать на кнопку <i class="delete"></i> рядом с наименование выбранного шаблона.<br>
               5) В открывшемся окне подтвердить удаление шаблона.`,
      open: false
    },
    {
      topicId: '4.12',
      question: 'Как запустить процедуру допуска?',
      answer: `1) Перейти в торги.<br>
               2) Нажать на кнопку <i class="dots"></i> в верхней части окна управления торгами.<br>
               3) В открывшемся окне задать параметры процедуры допуска: контроль нарушений, контроль допуска, особый порядок допуска.<br>
               4) Нажать <strong>«Начать допуск»</strong>.`,
      open: false
    },
    {
      topicId: '4.13',
      question: 'Как задать период, в который проводить активацию заявок/регистраций?',
      answer: `1)	Перейти на вкладку <em>«Настройки»</em> в разделе «Торги сегодня».<br>
               2) В предторговом периоде выбрать одно из значений: «в предторговом периоде» или «в любом периоде».`,
      open: false
    },
    {
      topicId: '4.14',
      question: 'Как просмотреть список товаров-аналогов?',
      answer: `1)	Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
               2) Выбрать в списке заявку с признаком «Да» в столбце «Аналоги».<br>
               3)	Активировать функцию контекстного меню <strong><em>«Просмотреть товары-аналоги»</strong></em> 
                ИЛИ 
                <strong><em>«Просмотреть заявку»</strong></em> и на форме просмотра подробной информации по заявке и нажать на элемент «Просмотреть товары-аналоги».<br>
               4) Отобразится форма просмотра списка товаров-аналогов`,
      open: false
    },
    {
      topicId: '4.15',
      question: 'Как завершить сессию и перенести ее в архив?',
      answer: `1) Нажать на кнопку <i class="dots"></i> в верхней части окна управления торгами.<br>
               2) Выбрать пункт <strong><em>«Завершить сессию»</em></strong>.<br>
               3)	В появившемся окне подтвердить перенос сессии в архив.`,
      open: false
    }
];

export const FAQ_DATA_TRADER: FaqItem[] =  [
  {
    topicId: '1.1',
    question: 'Как перейти в Каталог спроса?',
    answer: `1) Выбрать в меню раздел «Каталог» – подраздел «Каталог спроса».<br>
             2) Отобразится Каталог спроса.<br>
              ИЛИ <br>
             1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
             2) Для выбранной сессии активировать функцию контекстного меню <strong><em>«Перейти в Каталог спроса»</em></strong>.<br>
             3) Отобразится Каталог спроса.`,
    open: false
  },
  {
    topicId: '1.1',
    question: 'Как перейти в Каталог предложений?',
    answer: `1) Выбрать в меню раздел «Каталог» – подраздел «Каталог предложений».<br>
             2) Отобразится Каталог предложений.<br>
              ИЛИ <br>
             1) Перейти в раздел «Сессии» – «Расписание сессий».<br>
             2) Для выбранной сессии активировать функцию контекстного меню <strong><em>«Перейти в Каталог предложений»</em></strong>.<br>
             3) Отобразится Каталог предложений.`,
    open: false
  },
  {
    topicId: '1.2',
    question: 'Как перейти к просмотру заявки из Каталога спроса/Каталога предложений?',
    answer: `1) Выбрать в меню раздел «Каталог» – «Каталог спроса» / «Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             2) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.<br>
             3) Отобразится информация по заявке.`,
    open: false
  },
  {
    topicId: '1.2',
    question: 'Как отредактировать заявку?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса» / «Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Редактировать заявку»</em></strong>.<br>
             4) В появившемся окне подтвердить переход к редактированию заявки.<br>
             5) Откроется форма редактирования заявки, в которую необходимо внести изменения.<br>
             6) Сохранить по кнопке`,
    open: false
  },
  {
    topicId: '1.2',
    question: 'Как отменить заявку, поданную на сессию?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса» / «Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Отменить заявку»</em></strong>.<br>
             4) В появившемся окне подтвердить переход к редактированию заявки.`,
    open: false
  },
  {
    topicId: '1.3',
    question: 'Как зарегистрировать/отменить регистрацию на сессию в качестве покупателя/продавца?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса»/«Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Зарегистрироваться/отменить регистрацию на покупку / на продажу»</em></strong>.<br>
             4) В появившемся окне произвести необходимые настройки.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
  {
    topicId: '1.4',
    question: 'Как подать заявку на покупку/продажу из раздела «Каталог спроса»/«Каталог предложений»?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса»/«Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Подать заявку на покупку» / «Подать заявку на продажу»</em></strong>.<br>
             4) В открывшейся форме создания заявки заполнить блоки параметров.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
  {
    topicId: '1.5',
    question: 'Как просмотреть сумму задатка по заявке из раздела «Каталог спроса»/«Каталог предложений»?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса»/«Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть задаток по заявке»</em></strong>.<br>
             4) Отобразится окно с информацией о задатке по выбранной заявке.`,
    open: false
  },
  {
    topicId: '1.5',
    question: 'Как просмотреть сумму задатка на сессию из раздела «Каталог спроса»/«Каталог предложений»?',
    answer: `1) Перейти в раздел «Каталог» – «Каталог спроса»/«Каталог предложений».<br>
             2) Выбрать в списке необходимый товар/услугу.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть задаток на сессию»</em></strong>.<br>
             4) Отобразится страница с информацией о задатке.`,
    open: false
  },
  {
    topicId: '2.1',
    question: 'Как просмотреть расписание сессий?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) На странице «Расписание сессий» отобразятся сессии, дата проведения которых больше либо равна текущей дате.`,
    open: false
  },
  {
    topicId: '2.1',
    question: 'Как просмотреть информацию по заявкам, поданным на выбранную сессию?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимую сессию.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть заявки на сессию»</em></strong>.<br>
             4) Откроется подраздел «Управление заявками», в котором будут отображены заявки, поданные на выбранную сессию.`,
    open: false
  },
  {
    topicId: '2.2',
    question: 'Как просмотреть сумму задатка на сессию из раздела «Расписание сессий»?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимую сессию.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть задаток на сессию»</em></strong>.<br>
             4) Отобразится страница с информацией о задатке.`,
    open: false
  },
  {
    topicId: '2.3',
    question: 'Как подать заявку на покупку/продажу из раздела «Расписание сессий»?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимую сессию.<br>
             3) Активировать функцию контекстного меню <strong><em>«Подать заявку на покупку» / «Подать заявку на продажу»</em></strong>.<br>
             4) В открывшейся форме создания заявки заполнить блоки параметров.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
  {
    topicId: '2.3',
    question: 'Как подать адресную заявку на продажу?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимую сессию <em>(период сессии – «Период заключения адресных сделок», состояние периода – «Активный»)</em>.<br>
             3) Активировать функцию контекстного меню <strong><em>«Подать адресную заявку на продажу»</em></strong>.<br>
             4) В открывшейся форме создания заявки заполнить блоки параметров.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
  {
    topicId: '2.4',
    question: 'Как зарегистрировать/отменить регистрацию на сессию в качестве покупателя/продавца?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимую сессию.<br>
             3) Активировать функцию контекстного меню <strong><em>«Зарегистрироваться/отменить регистрацию на покупку / на продажу»</em></strong>.<br>
             4) В появившемся окне произвести необходимые настройки.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
  {
    topicId: '2.4',
    question: 'Как произвести пакетную регистрацию/отмену регистрации на сессию в качестве покупателя/продавца?',
    answer: `1) Перейти в раздел «Расписание сессий».<br>
             2) Выбрать в списке необходимые сессии.<br>
             3) Активировать кнопку <strong><em>«Зарегистрироваться/отменить регистрацию на покупку / на продажу»</em></strong>.<br>
             4) В появившемся окне произвести необходимые настройки.<br>
             5) Сохранить по кнопке.`,
    open: false
  },
 {
    topicId: '3.1',
    question: 'Как просмотреть заявки, поданные трейдером на выбранную сессию?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В параметрах фильтрации выбрать необходимую сессию.<br>
             3) Справа от параметров фильтрации отобразятся заявки, поданные на выбранную сессию.`,
    open: false
  },
  {
    topicId: '3.1',
    question: 'Как просмотреть подробную информацию по заявке?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong> или нажать на кнопку <i class="viewOffer"></i> на боковой панели.`,
    open: false
  },
  {
    topicId: '3.2',
    question: 'Как отредактировать заявку?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Редактировать заявку»</em></strong> или нажать на кнопку <i class="pencilEdit"></i>.<br>
             4) Во всплывающем окне подтвердить выполнение операции.<br>
             5) В открывшейся форме внести необходимые изменения.<br>
             6) Нажать <strong>«Подать заявку»</strong>.`,
    open: false
  },
  {
    topicId: '3.2',
    question: 'Как отменить заявку на покупку/продажу?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Отменить заявку»</em></strong> или нажать на кнопку <i class="cancel"></i> в боковой панели.<br>
             4) В появившемся окне подтвердить выполнение операции.`,
    open: false
  },
  {
    topicId: '3.2',
    question: 'Как удалить заявку, ранее отмененную трейдером или отклоненную работником?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Удалить заявку»</em></strong>  или нажать на кнопку <i class="delete"></i> в боковой панели.<br>
             4) В появившемся окне подтвердить выполнение операции.<br>
             ИЛИ <br>
             1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть заявку»</em></strong>.<br>
             4) В появившемся окне нажать на кнопку <strong>«Удалить заявку»</strong>.<br>
             5) Во всплывающем окне подтвердить выполнение операции.`,
    open: false
  },
  {
    topicId: '3.3',
    question: 'Как передать заявки другому трейдеру?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Передать заявки другому трейдеру»</em></strong> или нажать на кнопку <i class="transfer"></i> на боковой панели.<br>
             4) В появившемся окне выбрать трейдера и нажать кнопку <strong>«Передать»<strong>.`,
    open: false
  },
  {
    topicId: '3.4',
    question: 'Как просмотреть сумму задатка по заявке из раздела «Управление заявками»?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть задаток по заявке»</em></strong> или нажать на кнопку <i class="depositOffer"></i> на боковой панели.<br>
             4) Отобразится окно с информацией о задатке по выбранной заявке.`,
    open: false
  },
  {
    topicId: '3.4',
    question: 'Как просмотреть сумму задатка на сессию из раздела «Управление заявками»?',
    answer: `1) Перейти в раздел «Заявки» – «Управление заявками» – «Секция».<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного меню <strong><em>«Просмотреть задаток на сессию»</em></strong> или нажать на кнопку <i class="depositOffer"></i> на боковой панели.<br>
             4) Отобразится страница с информацией о задатке.`,
    open: false
  },
  {
    topicId: '4.1',
    question: 'Как перейти в торги?',
    answer: `– Перейти в меню «Сессии» – «Расписание сессий» – выбрать функцию контекстного меню <strong><em>«Перейти в торги»</em></strong>.<br>
             – В разделе «Торги сегодня» нажать на кнопку <strong>«Перейти в торги»</strong>.<br>
             – В окне «Вход в торги» нажать на кнопку <strong>«Перейти в торги»</strong>.`,
    open: false
  },
  {
    topicId: '4.2',
    question: 'Как просмотреть подробную информацию по заявке в разделе «Торги сегодня»?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) В контекстном меню выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.`,
    open: false
  },
  {
    topicId: '4.2',
    question: 'Как просмотреть изменения по заявке?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать необходимую заявку.<br>
             3) В контекстном меню выбрать функцию <strong><em>«Показать изменения»</em></strong>.<br>
             4) В открывшейся форме отобразится информация о предыдущей и текущей версиях заявки.`,
    open: false
  },
  {
    topicId: '4.3',
    question: 'Как отредактировать заявку в разделе «Торги сегодня»?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать необходимую заявку.<br>
             3) В контекстном меню выбрать функцию <strong><em>«Редактировать заявку»</em></strong>.<br>
             4) В открывшейся форме скорректировать доступные для редактирования поля заявки.<br>
             5) Нажать на кнопку <strong>«Сохранить»</strong>.<br>
             ИЛИ <br>
             1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать необходимую заявку.<br>
             3) В контекстном меню выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
             4) Нажать на кнопку <strong>«Редактировать заявку»</strong>.<br>
             5)	Скорректировать доступные для редактирования поля заявки.<br>
             5) Нажать на кнопку <strong>«Сохранить»</strong>.`,
    open: false
  },
  {
    topicId: '4.4',
    question: 'Как добавить заявку в наблюдаемые?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать в списке необходимую заявку. <br>
             3) В контекстном меню выбрать функцию <strong><em>«Добавить в наблюдаемые»</em></strong>.<br>
             4) Название функции изменится на <strong><em>«Добавлено в наблюдаемые»</em></strong>, а рядом с номером лота появится иконка <i class="isObserved"></i>.<br>
                ИЛИ <br>
             1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать в списке необходимую заявку.<br>
             3) В контекстном меню заявки выбрать функцию <strong><em>«Просмотреть заявку»</em></strong>.<br>
             4) В открывшейся форме просмотра заявки нажать на кнопку <i class="isNotObserved"></i>.<br>
             5) Кнопка изменит вид на <i class="isObserved"></i>`,
    open: false
  },
  {
    topicId: '4.4',
    question: 'Как удалить заявку из наблюдаемых?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать в списке заявку, в столбце рядом с номером лота которой отображается иконка <i class="isObserved"></i>.<br>
             3) В контекстном меню выбрать <strong><em>«Добавлено в наблюдаемые»</em></strong>.<br>
             4) Название функции изменится на <strong><em>«Добавить в наблюдаемые»</em></strong>.<br>
                ИЛИ <br>
             1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) Выбрать в списке заявку, в столбце рядом с номером лота которой отображается иконка <i class="isObserved"></i>.<br>
             3) В контекстном меню выбрать <strong><em>«Просмотреть заявку»</em></strong>.<br>
             4) В открывшейся форме нажать на кнопку <i class="isObserved"></i>.`,
    open: false
  },
  {
    topicId: '4.5',
    question: 'Как просмотреть свои регистрации на торговую сессию?',
    answer: `1) Перейти на вкладку <em>«Мои регистрации»</em>.<br>
             2) Отобразится список регистраций на выбранную сессию.`,
    open: false
  },
  {
    topicId: '4.6',
    question: 'Как просмотреть сумму задатка по заявке?',
    answer: `1) Перейти на вкладку <em>«Мои заявки»</em> или <em>«Торги»</em>.<br>
             2) В списке заявок выбрать необходимую.<br>
             3) Активировать функцию контекстного <strong><em>«Просмотреть задаток по заявке»</em></strong>.<br>
             4) Отобразится информация о задатке по выбранной заявке.<br>
              ИЛИ <br>
             1) Перейти на вкладку <em>«Задаток»</em>.<br>
             2)	Отобразится информация о сумме своего задатка в рамках участника <em>(для трейдера брокера – в разрезе клиентов брокеров)</em>.`,
    open: false
  },
  {
    topicId: '4.7',
    question: 'Как подать ставку на покупку?',
    answer: `1) Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
             2) Выбрать необходимую заявку.<br>
             3) Вызвать контекстное меню и активировать функцию <strong><em>«Подать ставку на покупку»</em></strong> или нажать на кнопку <strong>«Купить»</strong> в столбце «Время подачи ставки».<br>
             4) В открывшейся форме просмотра заявки с помощью кнопок установить стоимость и нажать на кнопку <strong>«Купить лот № <номер лота>»</strong>.`,
    open: false
  },
  {
    topicId: '4.8',
    question: 'Как просмотреть реестр встречных предложений?',
    answer: `1) Перейти на вкладку <em>«Торги»</em> или <em>«Мои заявки»</em> в разделе «Торги сегодня».<br>
             2) Выбрать необходимую заявку.<br>
             3) Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</em></strong>.`,
    open: false
  },
  {
    topicId: '4.8',
    question: 'Как направить встречное предложение?',
    answer: `1) Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
             2) Выбрать необходимую заявку.<br>
             3) Вызвать контекстное меню и активировать функцию <strong><em>«Направить встречное предложение»</em></strong>.<br>
             4) В открывшемся окне необходимо ввести цену.<br>
             5) Нажать на кнопку <strong>«Подать встречное предложение»</strong>.`,
    open: false
  },
  {
    topicId: '4.8',
    question: 'Как принять встречное предложение?',
    answer: `1) Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
             2) Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</em></strong>.<br>
             3) Выбрать подходящее предложение в списке.<br>
             4) Нажать на кнопку <strong>«Принять встречное предложение»</strong>.`,
    open: false
  },
  {
    topicId: '4.8',
    question: 'Как отменить свое встречное предложение, направленное на заявку на продажу?',
    answer: `1) Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
             2) Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</em></strong>.<br>
             3) Найти своё предложение.<br>
             4) Нажать на кнопку <strong>«Удалить встречное предложение»</strong>.`,
    open: false
  },
  {
    topicId: '4.9',
    question: 'Как просмотреть подробную информацию по сделке?',
    answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
             2) Выбрать необходимую сделку.<br>
             3) Вызвать контекстное меню и активировать функцию <strong><em>«Просмотреть сделку»</em></strong>.`,
    open: false
  },
  {
    topicId: '4.9',
    question: 'Как сформировать лист учета сделки?',
    answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
             2) Выбрать необходимую сделку.<br>
             3) Вызвать контекстное меню и активировать функцию <strong><em>«Сформировать лист учета сделки»</em></strong>.`,
    open: false
  },
  {
    topicId: '4.9',
    question: 'Как просмотреть информацию по биржевому сбору?',
    answer: `1) Перейти на вкладку <em>«Сделки»</em>.<br>
             2) Нажать на кнопку <strong>«Статистика»</strong>.`,
    open: false
  },
  {
    topicId: '4.10',
    question: 'Как направить предложение на продажу для заключения сделки по выбранной заявке на покупку на условиях продавца?',
    answer: `1) Перейти на вкладку <em>«Торги»</em>.<br>
             2) Выбрать в списке необходимую заявку на покупку.<br>
             3)	Активировать функцию контекстного меню <strong><em>«Подать заявку»</strong></em> или нажать на кнопку <strong>«Подать заявку»</strong> в столбце «Время подачи ставки», 
             или нажать кнопку <strong>«Подать заявку»</strong> на форме просмотра заявки.<br>
             4)	В открывшейся форме просмотра заявки на покупку скорректировать необходимые параметры.<br>
             5)	Направить предложение на продажу – кнопка <strong> «Подать заявку на лот <№></strong>».`,
    open: false
  },
  {
    topicId: '4.11',
    question: 'Как отправить сообщение работнику?',
    answer: `1) Перейти на вкладку <em>«Сообщения»</em>.<br>
             2) Откроется чат с работником.<br>
             3) Ввести текст сообщения в специальное поле.<br>
             4) Нажать <strong>«Отправить»</strong>.`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как подать заявку с товарами-аналогами?',
    answer: `1)	Перейти в раздел «Расписание сессий».<br>
              2)	Выбрать в списке сессию, в столбце «Аналоги» которой установлен признак <em>«Да»</em>.<br>
              3)	Активировать функцию контекстного меню <strong><em>«Подать заявку на покупку»</strong></em>.<br>
              4)	Откроется форма создания заявки на покупку.<br>
              5)	Добавить товар через НСИ <em>(в окне «Добавление товара/услуги на покупку» выбрать вариант «Добавить товар»)</em>.<br>
              6)	Заполнить данные на всех шагах подачи заявки.<br>
              7)	Нажать на кнопку <strong>«Подать заявку»</strong>.`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как просмотреть список товаров-аналогов?',
    answer: `1)	Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
              2)	Выбрать в списке заявку с признаком <em>«Да»</em> в столбце «Аналоги».<br>
              3)	Активировать функцию контекстного меню <strong><em>«Просмотреть товары-аналоги»</strong></em>
               ИЛИ <strong><em>«Просмотреть заявку»</strong></em> и на форме просмотра подробной информации по заявке и нажать на элемент «Просмотреть товары-аналоги».<br>
              4)	Отобразится форма просмотра списка товаров-аналогов.`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как отклонить встречное предложение?',
    answer: `1)	Перейти на вкладку <em>«Торги»</em> или <em>«Мои заявки»</em> в разделе «Торги сегодня».<br>
            2)	Выбрать необходимую заявку.<br>
            3)	Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</strong></em>.<br>
            4)	На открывшейся форме нажать на кнопку <strong>«Отклонить встречное предложение»</strong> (доступна в период корректировки заявок).`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как принять условия встречного предложения?',
    answer: `1)	Перейти на вкладку <em>«Торги»</em> или <em>«Мои заявки»</em> в разделе «Торги сегодня».<br>
            2)	Выбрать необходимую заявку.<br>
            3)	Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</strong></em>.<br>
            4)	На открывшейся форме нажать на кнопку <strong>«Принять встречное предложение»</strong>.`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как восстановить встречное предложение с товаром-аналогом?',
    answer: `1)	Перейти на вкладку <em>«Торги»</em> или <em>«Мои заявки»</em> в разделе «Торги сегодня».<br>
            2)	Выбрать необходимую заявку.<br>
            3)	Вызвать контекстное меню и активировать функцию <strong><em>«Реестр встречных предложений»</strong></em>.<br>
            4)	На открывшейся форме нажать на кнопку <strong>«Восстановить встречное предложение»</strong>.`,
    open: false
  },
  {
    topicId: '4.12',
    question: 'Как подать встречное предложение с товаром-аналогом?',
    answer: `1)	Перейти на вкладку <em>«Торги»</em> в разделе «Торги сегодня».<br>
            2)	Выбрать необходимую заявку.<br>
            3)	Вызвать контекстное меню и активировать функцию <strong><em>«Направить встречное предложение»</strong></em>.<br>
            4)	На форме подачи встречного предложения нажать на элемент <strong>«Предложить аналог из каталога товаров»</strong>. Отобразится окно с перечнем товаров-аналогов.<br>
            5)	Нажать на элемент <strong>«Добавить»</strong>. Товар-аналог и его характеристики отобразятся на форме подачи встречного предложения в блоке с дополнительными параметрами товара.<br> 
            6)	Скорректировать необходимые параметры.<br> 
            7)	Нажать на кнопку <strong>«Подать встречное предложение»</strong>`,
    open: false
  },
]
